import { render, staticRenderFns } from "./ProofOfDeliveryConfiguration.vue?vue&type=template&id=62c1c577&scoped=true&"
import script from "./ProofOfDeliveryConfiguration.vue?vue&type=script&lang=js&"
export * from "./ProofOfDeliveryConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./ProofOfDeliveryConfiguration.vue?vue&type=style&index=0&id=62c1c577&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c1c577",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62c1c577')) {
      api.createRecord('62c1c577', component.options)
    } else {
      api.reload('62c1c577', component.options)
    }
    module.hot.accept("./ProofOfDeliveryConfiguration.vue?vue&type=template&id=62c1c577&scoped=true&", function () {
      api.rerender('62c1c577', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ProofOfDelivery/ProofOfDeliveryConfiguration.vue"
export default component.exports